import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { IconoirXmark } from '@ey-xd/motif-icon';
import {
  ButtonSizes,
  MOTIF_MODAL_DATA,
  MotifButtonModule,
  MotifIconModule,
  MotifModalModule,
  MotifModalRef,
} from '@ey-xd/ng-motif';
import { ConfirmModalData } from '@models';
import { TranslatePipe } from '@ngx-translate/core';

interface ConfirmModalAction {
  cancel: boolean;
  confirm: boolean;
}

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [MotifModalModule, MotifButtonModule, TranslatePipe, MotifIconModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalComponent {
  public readonly BUTTON_SIZE = ButtonSizes.LARGE;
  protected readonly closeIcon = IconoirXmark;

  #dialogRef = inject(MotifModalRef<ConfirmationModalComponent, ConfirmModalAction>);
  public readonly data = inject<ConfirmModalData>(MOTIF_MODAL_DATA);

  public cancelButton = signal(this.data.cancelButton);
  public confirmButton = signal(this.data.confirmButton);
  public action = signal(this.data.confirmAction);

  handleAction(cancel: boolean, confirm: boolean): void {
    const action = this.action()
    this.#dialogRef.close({ cancel, confirm, action });
  }

  onClose(): void {
    this.#dialogRef.close(null);
  }

  onCancel(): void {
    this.handleAction(true, false);
  }

  onConfirm(): void {
    this.handleAction(false, true);
  }
}
